import React from 'react';
import {BLOCKS, INLINES, MARKS} from '@contentful/rich-text-types';

import {
	ContentfulBold,
	ContentfulEmbeddedAsset,
	ContentfulEmbeddedEntry,
	ContentfulEmbeddedEntryInline,
	ContentfulEntryLink,
	ContentfulParagraph,
} from './Subcomponents';

export const options = {
	renderMark: {
		[MARKS.BOLD]: (text) => <ContentfulBold>{text}</ContentfulBold>,
	},
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => <ContentfulParagraph>{children}</ContentfulParagraph>,
		[BLOCKS.EMBEDDED_ENTRY]: (node) => <ContentfulEmbeddedEntry data={node.data} />,
		[INLINES.EMBEDDED_ENTRY]: (node) => <ContentfulEmbeddedEntryInline data={node.data} />,
		[INLINES.ENTRY_HYPERLINK]: (node, children) =>
			<ContentfulEntryLink data={node.data}>{children}</ContentfulEntryLink>,
		[BLOCKS.EMBEDDED_ASSET]: (node, children) => (
			<ContentfulEmbeddedAsset data={node.data}>{children}</ContentfulEmbeddedAsset>
		),
	},
};
